/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * themeStore.ts — them\1 \2tore (services/operator-web-app).
 */

/**
 * Стор темы для подписки в React. Состояние синхронизируется с localStorage и document.
 */
import { createStore } from 'zustand';
import { applyTheme, getTheme, type Theme } from '@/config/theme';

export interface ThemeStore {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

export const themeStore = createStore<ThemeStore>((set, get) => ({
  theme: getTheme(),
  setTheme: (theme: Theme) => {
    applyTheme(theme);
    set({ theme });
  },
  toggleTheme: () => {
    const next: Theme = get().theme === 'dark' ? 'light' : 'dark';
    get().setTheme(next);
  },
}));
